<template>
  <form>
    <div class="u-scroller u-space--h u-space--large">
      <button
        type="button"
        class="card card--top"
        aria-label="Top"
        :disabled="!isYourGo || !topStack.length"
        @click="fromTheTop"
      />
      <span />
      <button
        v-for="(card, i) in cardStack"
        :key="i"
        :class="`card card--${card.colour.toLowerCase()}`"
        type="button"
        :aria-label="card.colour"
        :disabled="!isYourGo || (card.id === 0 && picked > 0)"
        @click="pickCard(i, card.id)"
      />
      <span
        :class="
          `card card--last ${
            lastPicked ? 'card--active' : ''
          } card--${lastPicked}`
        "
      />
    </div>
  </form>
</template>

<script>
import { mapState, mapGetters } from "vuex";

export default {
  data() {
    return {
      picked: 0,
      lastPicked: ""
    };
  },

  computed: {
    ...mapGetters(["yourGo", "topStack", "cardStack"]),
    ...mapState(["status"]),

    isYourGo() {
      return (
        this.yourGo && (this.status === "waiting" || this.status === "cards")
      );
    }
  },

  methods: {
    pickCard(stackIndex, colourIndex) {
      this.$store.commit("pickCard", colourIndex);
      this.$store.commit("removeCard", stackIndex);
      this.picked++;

      if (colourIndex === 0 || this.picked === 2) {
        this.picked = 0;
        this.$store.commit("setStatus", "finishing");
        this.$store.dispatch("nextGo");
      }
    },

    fromTheTop() {
      const topCard = this.topStack[0];
      if (!topCard) {
        return;
      }
      this.lastPicked = topCard.colour.toLowerCase();
      setTimeout(() => {
        this.lastPicked = "";
      }, 1000);

      this.$store.commit("pickCard", topCard.id);
      this.$store.commit("removeCard", 5);

      this.picked++;

      if (this.picked === 2) {
        this.picked = 0;
        this.$store.commit("setStatus", "finishing");
        this.$store.dispatch("nextGo");
      }
    }
  }
};
</script>

<style>
.card {
  width: 90px;
  height: 120px;
  border: 5px solid #fff;
  border-radius: 15px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex-direction: column;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
  font-size: 1em;
  font-weight: 700;
  position: relative;
  overflow: hidden;
  color: var(--black);
  flex-shrink: 0;
}

.card:after {
  content: "🚂";
  position: absolute;
  font-size: 3rem;
  filter: saturate(0);
  mix-blend-mode: overlay;
  transform: translate(-50%, -50%) rotate(-90deg) scaleX(-1);
  top: 50%;
  left: 50%;
}

@media (min-width: 1048px) {
  .card {
    width: 120px;
    height: 150px;
  }

  .card:after {
    font-size: 4em;
  }
}

.card--last {
  position: absolute;
  left: 0;
  transform: perspective(500px) rotateY(-90deg);
  transform-style: preserve-3d;
  transition: 300ms transform;
  visibility: hidden;
  opacity: 0;
}

.card--active {
  transform: perspective(500px) rotateY(0deg);
  visibility: visible;
  opacity: 1;
}

:root {
  --red: #e74c3c;
  --pink: #cca5da;
  --green: #78e08f;
  --blue: #0984e3;
  --orange: #f18f3e;
  --rainbow: linear-gradient(
    var(--red),
    var(--orange),
    var(--yellow),
    var(--green),
    var(--blue),
    var(--pink)
  );
  --off-white: #f1f2f6;
  --yellow: #f6e58d;
  --grey: #a5b1c2;
  --black: #2d3436;
}

.card--top {
  background: var(--grey);
}

.card--red {
  background: var(--red);
  color: var(--off-white);
}

.card--pink {
  background: var(--pink);
}

.card--green {
  background: var(--green);
}

.card--blue {
  background: var(--blue);
  color: var(--off-white);
}

.card--orange {
  background: var(--orange);
  color: var(--off-white);
}

.card--rainbow {
  background: var(--rainbow);
}

.card--white {
  background: var(--off-white);
}

.card--yellow {
  background: var(--yellow);
}

.card--black {
  background: var(--black);
  color: var(--off-white);
}

.card--white:after {
  mix-blend-mode: normal;
  opacity: 0.5;
}

.card--top:after {
  opacity: 0.3;
}
</style>
